import { persistedStore } from './../../../app/store/appStore'
import {
  createListenerMiddleware,
  type TypedStartListening,
} from '@reduxjs/toolkit'

import { invalidateAccessToken } from '../../../shared/api'
import { useLogoutMutation } from '../api/sessionApi'

// import { logoutThunk } from '../../logout/model/logout'

export const invalidateAccessTokenListener = createListenerMiddleware()

// @see https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
export type TypedListening = TypedStartListening<RootState, AppDispatch>

export const startInvalidateAccessTokenListener =
  invalidateAccessTokenListener.startListening as TypedListening

startInvalidateAccessTokenListener({
  actionCreator: invalidateAccessToken,
  effect: async (_, api) => {
    // In the future here may be logic with refresh access token
    // @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#preventing-multiple-unauthorized-errors
    // api.dispatch(logoutThunk())
    // const [logout] = useLogoutMutation()

    const state = api.getState()
    const token = state?.session?.accessToken

    try {
      persistedStore.purge()
      window.location.href = '/login'
      localStorage.setItem('persist:root', '')
    } catch (error) {
      console.error('Ошибка при разлогине:', error)
    }
  },
})
